const villaSec3_Object = payload => {
  return {
    type: "villaSec3",
    payload
  };
};

export default villaSec3_Object;
